<template>
    <div v-bind:class="app_container_class" id="app-container">
        <div class="container-fluid full-height d-flex" v-if="this.$root.cart_is_loaded && this.$root.product_is_loaded && this.$root.valid_tpv() === true">
            <div class="col-12 p-4 full-height d-flex" id="payment-component-container">
                <payment-terminal-component />
            </div>
        </div>
    </div>
    <transition name="content-fade">
        <footer-component
            :section="section"/>
    </transition>
</template>

<script>
import PaymentTerminal from "./PaymentTerminal";
import FooterComponent from "../footer/Footer";

export default {
    name: "Payment",

    components: {
        'payment-terminal-component': PaymentTerminal,
        'footer-component': FooterComponent,
    },

    data() {
        return {
            app_container_class: 'd-flex p-0 m-0 bg-phoenix-paiement',
        }
    },
    methods: {
        init()
        {
            this.$root.current_event_is_loaded.push('loading-payment');
            this.$root.current_loading_message = this.trans.get('kiosk.loading-paiement');
        },
    },



    created() {
        this.$root.show_btn_confirmer = false;
        this.$root.global_cancel_btn_disabled = false;
        this.init();
    },

    emits: [ 'send' ],

    props: {
        locale: String,
        section: String,
    },
}
</script>

<style scoped>

</style>
